import { Live2dWidgetBase } from './main'


export default class Live2dWidgetIife extends Live2dWidgetBase {

}
